<template>
  <div class="wr-panel">
    <div class="wr-panel__header">
      <v-icon size="18" color="#e0e0e0" class="mr-2">mdi-account-clock</v-icon>
      <span>Waiting Room</span>
      <span class="wr-panel__count">{{ guests.length }}</span>
      <v-btn icon size="x-small" variant="text" color="#9e9e9e" class="ml-auto" @click="$emit('close')">
        <v-icon size="16">mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="wr-panel__list">
      <div v-for="guest in guests" :key="guest.identity" class="wr-panel__item">
        <v-avatar size="32" color="#333" class="mr-3">
          <v-icon size="18" color="#9e9e9e">mdi-account</v-icon>
        </v-avatar>
        <span class="wr-panel__name">{{ guest.name }}</span>
        <div class="wr-panel__actions">
          <v-btn
            size="small"
            color="success"
            variant="flat"
            class="mr-1"
            @click="$emit('admit', guest.identity)"
          >Admit</v-btn>
          <v-btn
            size="small"
            color="error"
            variant="outlined"
            @click="$emit('deny', guest.identity)"
          >Deny</v-btn>
        </div>
      </div>

      <div v-if="guests.length === 0" class="wr-panel__empty">
        No one is waiting
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitingRoomPanel',

  props: {
    guests: { type: Array, default: () => [] },
  },

  emits: ['admit', 'deny', 'close'],
};
</script>

<style scoped>
.wr-panel {
  position: absolute;
  bottom: 80px;
  right: 16px;
  width: 320px;
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 10px;
  overflow: hidden;
  z-index: 200;
  box-shadow: 0 4px 24px rgba(0,0,0,0.5);
}

.wr-panel__header {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #252525;
  border-bottom: 1px solid #333;
  color: #e0e0e0;
  font-size: 0.85rem;
  font-weight: 600;
}

.wr-panel__count {
  background: #ef6c00;
  color: #fff;
  border-radius: 10px;
  font-size: 0.65rem;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  margin-left: 6px;
}

.wr-panel__list {
  max-height: 280px;
  overflow-y: auto;
  padding: 8px 0;
}

.wr-panel__item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
}

.wr-panel__name {
  flex: 1;
  font-size: 0.85rem;
  color: #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wr-panel__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.wr-panel__empty {
  text-align: center;
  color: #616161;
  font-size: 0.8rem;
  padding: 16px;
}
</style>
